// TODO(PC-9602): we may want to optimize the display of images on the web
// instead of just using the raw image from /public/images
export const BACKGROUND_IMAGE_SOURCE = { uri: '/images/BannerRectangle.png' }
